import { IAgentDictionaryApi } from '@/types';

export class AgentDictionaryItem {
    id: number;
    login?: string;
    name: string;

    constructor(data: IAgentDictionaryApi) {
        this.id = data.id;
        this.name = data.name;
        this.login = data.login;
    }
}
